// announcement.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {
  private apiUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  // Announcement CRUD

  addAnnouncement(data: any, parishId: any): Observable<{ message: string }> {
    const announceUrl = `${this.apiUrl}/api/v1/Announcements/${parishId}/add`;
    return this.http.post<{ message: string }>(announceUrl, data);
  }
 
  updateAnnouncement(id: number, updatedData: any): Observable<{ message: string }> {
    const updateAnnouncementUrl = `${this.apiUrl}/api/v1/Announcements/updateAnnouncement/${id}`;
    return this.http.put<{ message: string }>(updateAnnouncementUrl, updatedData);
  }

  deleteAnnouncement(dataId: number): Observable<{ message: string }> {
    const deleteAnnouncementUrl = `${this.apiUrl}/api/v1/Announcements/delete/${dataId}`;
    return this.http.delete<{ message: string }>(deleteAnnouncementUrl);
  }

  // Get announcements

  getPendingAnnouncements(parishId: string): Observable<any[]> {
    const pendingAnnouncementsUrl = `${this.apiUrl}/api/v1/Announcements/get/${parishId}/all`;
    return this.http.get<any[]>(pendingAnnouncementsUrl);
  }

  getPartialAnnouncements(): Observable<any[]> {
    const partialAnnouncementsUrl = `${this.apiUrl}/p2p/prequalification/admin/allpartitallyapproved`;
    return this.http.get<any[]>(partialAnnouncementsUrl);
  }

  getApprovedAnnouncements(): Observable<any[]> {
    const approvedAnnouncementsUrl = `${this.apiUrl}/api/v1/Announcements/get/all`;
    return this.http.get<any[]>(approvedAnnouncementsUrl);
  }

  getScheduled(): Observable<any[]> {
    const announcementsUrl = `${this.apiUrl}/api/v1/Announcements/get/scheduled`;
    return this.http.get<any[]>(announcementsUrl);
  }

  getApprovedPostedAnnouncements(): Observable<any[]> {
    const approvedAnnouncementsUrl = `${this.apiUrl}/p2p/prequalification/admin/allposted`;
    return this.http.get<any[]>(approvedAnnouncementsUrl);
  }

  getApprovedNotPostedAnnouncements(): Observable<any[]> {
    const approvedAnnouncementsUrl = `${this.apiUrl}/p2p/prequalification/admin/allnotposted`;
    return this.http.get<any[]>(approvedAnnouncementsUrl);
  }

  getRejectedAnnouncements(): Observable<any[]> {
    const rejectedAnnouncementsUrl = `${this.apiUrl}/p2p/prequalification/admin/allrejected`;
    return this.http.get<any[]>(rejectedAnnouncementsUrl);
  }

  getDeletedAnnouncements(): Observable<any[]> {
    const deletedAnnouncementsUrl = `${this.apiUrl}/api/v1/Announcements/getDeleted`;
    return this.http.get<any[]>(deletedAnnouncementsUrl);
  }

  getAnnouncements(): Observable<any[]> {
    const announcementsUrl = `${this.apiUrl}/p2p/prequalification/admin/allpending`;
    return this.http.get<any[]>(announcementsUrl);
  }

  // Additional announcement details

  getAnnouncementById(id: any): Observable<any> {
    const announcementUrl = `${this.apiUrl}/p2p/prequalification/admin/findbyid/${id}`;
    return this.http.get<any>(announcementUrl);
  }

  getApplicationsBySupplierId(supplierid: any): Observable<any> {
    const announcementUrl = `${this.apiUrl}/p2p/prequalification/apply/foronesupplier/${supplierid}`;
    return this.http.get<any>(announcementUrl);
  }

  getRequirementsByAnnId(jobId: any): Observable<any> {
    const url = `${this.apiUrl}/P2PSolution/p2p/prequalification/requirements/categories/findby/${jobId}`;
    return this.http.get<any>(url, {});
  }

  updateAnnouncementStatus(dataId: number, payload: { status: string }): Observable<{ message: string }> {
    const url = `${this.apiUrl}/api/v1/Announcements/updateAnnouncement/${dataId}`;
    return this.http.put<{ message: string }>(url, payload);
  }

  updateAnnouncementStatusDesk(data: any): Observable<{ message: string }> {
    const url = `${this.apiUrl}/p2p/prequalification/admin/desk/verify`;
    return this.http.put<{ message: string }>(url, data);
  }

  getTenderCategoryById(categoryId: any): Observable<any> {
    const url = `${this.apiUrl}/p2p/tendercategories/find/${categoryId}`;
    return this.http.get<any>(url, {});
  }

  // New lookup endpoints

  // Get Groups – used to populate lookup data for target "Groups"
  getGroups(): Observable<any> {
    const url = `${this.apiUrl}/api/v1/Announcements/groups`;
    return this.http.get<any>(url);
  }

  // Get Communities – used to populate lookup data for target "Communities"
  getCommunities(parishId: string): Observable<any> {
    const url = `${this.apiUrl}/api/v1/Announcements/communities/${parishId}`;
    return this.http.get<any>(url);
  }

  // Get Families – used to populate lookup data for target "Families"
  getFamilies(parishId: string): Observable<any> {
    const url = `${this.apiUrl}/api/v1/Family/fetch/families/${parishId}`;
    return this.http.get<any>(url);
  }
}
